import styled, { css } from 'styled-components';
import { Button } from 'antd';
import ImgCrop from 'antd-img-crop';

type Props = {
    children: React.ReactNode;
};

export const UploadButton = styled(Button)``;

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    max-width: 200px;
    flex-direction: column;
    height: auto;
`;
export const Title = styled.p`
    ${({ theme }) => css`
        color: ${theme.colors.font};
        font-size: ${theme.fontSizes.little};
        margin-bottom: 0.5rem;
    `}
`;

interface IImage {
    src: string;
    alt: string;
}

export const Image = styled.div<IImage>`
    display: flex;
    justify-content: flex-start;
    margin: 10px;
    width: 100%;
    height: 200px;
    align-items: flex-start;
    background-image: url(${({ src }) => src});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 10px;
`;

export const StyledImgCrop = styled(ImgCrop)<Props>``;
